export const CertificateStatus = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  REPROVED: 'REPROVED'
}

export const CertificateStatusColors = {
  ACTIVE: 'var(--theme-green)',
  PENDING: 'var(--theme-primary)',
  REPROVED: 'var(--danger)'
}

export const CertificateStatusListForSelect = [
  { value: CertificateStatus.ACTIVE, label: 'Emitido' },
  { value: CertificateStatus.PENDING, label: 'Em certificação' }
]

export const getCertificateStatusText = (status) => {
  switch (status.toUpperCase()) {
    case CertificateStatus.ACTIVE:
      return 'Emitido'
    case CertificateStatus.PENDING:
      return 'Em certificação'
    case CertificateStatus.REPROVED:
      return 'Reprovado'
    default:
      return 'Não definido'
  }
}
